import { useState, useEffect, useRef } from "react";

const PostalCodeSearch = ({ onLocationSelect, getUserDetail }) => {
  const postCode = getUserDetail?.result?.address?.postcode;
  const [postalCode, setPostalCode] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (postCode) {
      setPostalCode(postCode);
    }
  }, [postCode]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const searchPostcode = async (query) => {
    if (query.length < 2) {
      setSuggestions([]);
      return;
    }

    try {
      const response = await fetch(
        `https://api.ideal-postcodes.co.uk/v1/autocomplete/addresses?api_key=${process.env.REACT_APP_IDEAL_POSTCODES_API_KEY}&q=${encodeURIComponent(query)}`
      );
      const data = await response.json();
      
      if (data.result?.hits) {
        setSuggestions(data.result.hits);
        setShowSuggestions(true);
      }
    } catch (error) {
      console.error("Postcode search error:", error);
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setPostalCode(value);
    searchPostcode(value);
  };

  const handleSelectSuggestion = async (suggestion) => {
    setShowSuggestions(false);
    setSuggestions([]);

    try {
      const response = await fetch(
        `https://api.ideal-postcodes.co.uk/v1/udprn/${suggestion.udprn}?api_key=${process.env.REACT_APP_IDEAL_POSTCODES_API_KEY}`
      );
      const data = await response.json();

      if (data.result) {
        const locationData = {
          lat: data.result.latitude,
          lng: data.result.longitude,
          postalCode: data.result.postcode,
        };
        setPostalCode(data.result.postcode);
        onLocationSelect(locationData);
      }
    } catch (error) {
      console.error("Postcode lookup error:", error);
    }
  };

  return (
    <div ref={wrapperRef} style={{ position: "relative" }}>
      <input
        type="text"
        placeholder="London, SW6 4BW"
        value={postalCode}
        onChange={handleInputChange}
        style={{
          width: "100%",
          padding: "10px",
          fontSize: "16px",
        }}
      />
      {showSuggestions && suggestions.length > 0 && (
        <ul
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            backgroundColor: "white",
            border: "1px solid #ddd",
            borderRadius: "4px",
            maxHeight: "200px",
            overflowY: "auto",
            margin: "4px 0 0 0",
            padding: 0,
            listStyle: "none",
            zIndex: 1000,
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
          }}
        >
          {suggestions.map((suggestion, index) => (
            <li
              key={index}
              onClick={() => handleSelectSuggestion(suggestion)}
              style={{
                padding: "10px",
                cursor: "pointer",
                borderBottom: index < suggestions.length - 1 ? "1px solid #eee" : "none",
              }}
              onMouseEnter={(e) => (e.target.style.backgroundColor = "#f5f5f5")}
              onMouseLeave={(e) => (e.target.style.backgroundColor = "white")}
            >
              {suggestion.suggestion}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default PostalCodeSearch;
